import React, { useState } from 'react';
import classes from './EditNameModal.module.css';
import { FaArrowLeft, FaXmark } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const EditNameModal = ({ isOpen, onClose, currentName = '', onSave }) => {
  const [name, setName] = useState(currentName);
  const [loading, setLoading] = useState(false);

  const {t}=useTranslation();

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    await onSave(name.trim());
    setLoading(false);
  };

  return (
    <div className={classes.overlay} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>

        <div className={classes.header_section}>
          <div className={classes.back_button} onClick={onClose}>
            <FaArrowLeft className={classes.back_icon} />
          </div>
          <h2 className={classes.header_text}>{t("349")}</h2>
          <div className={classes.close_button} onClick={onClose}>
            <FaXmark className={classes.close_icon} />
          </div>
        </div>

        <form onSubmit={handleSubmit} className={classes.form}>
          <div className={classes.user_details_container}>
            <p className={classes.user_name}>{t("351")}</p>
            <input
              type="text"
              className={classes.user_name_input}
              name="name"
              placeholder={t("352")}
              value={name}
              maxLength={50}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className={classes.button_row}>
            <button type="button" className={classes.cancel_btn} onClick={onClose}>
              {t("247")}
            </button>
            <button type="submit" className={classes.save_changes_btn} disabled={loading || !name.trim()}>
              {loading ? t("248") : t("30")}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
};

export default EditNameModal;